const merge = (request, modify) => {
    const result = { ...request, ...modify };
    for (const key in modify) {
        if (modify[key] &&
            request[key] &&
            typeof modify[key] === 'object' &&
            typeof request[key] === 'object') {
            result[key] = merge(request[key], modify[key]);
        }
    }
    return result;
};
export const adjust = (modify) => (request) => merge(request, modify);
